import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Switch,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { tokens } from "../../theme";
import { useLayoutEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import LoadingBackDrop from "../global/LoadingBackDrop";
import { getPayload } from "../../services/api";
import dayjs, { utc } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import ConcreteCubeAccordingData from "./ConcreteCubeAccordingData";
import {
  AssignmentTurnedIn,
  CalendarMonth,
  DeleteForever,
  FileDownload,
  FormatListBulleted,
  PictureAsPdf,
  ViewInAr,
} from "@mui/icons-material";

// dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ConcreteCubesToBeCasted = ({
  castingCubesData,
  setSelectedRequestId,
  setOpenLabSheetDialog,
}) => {
  console.log("casting data ", castingCubesData);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `JOB/${row?.labRequest.year}/${String(
            row?.labRequest.autoIdByYear,
          ).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 100,
      },

      {
        accessorKey: "labRequest.regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "labRequest.institute.instituteName",
        header: "Institute/Contracor",
        size: 80,
      },
      {
        accessorKey: "castingDate",
        header: "Casting Date",
        size: 80,
      },
      {
        accessorKey: "testDate",
        header: "Test Date",
        size: 80,
      },
      {
        accessorKey: "startingSerialNo",
        header: "Serial No",
        size: 80,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: castingCubesData,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor: "#fdff85ff",
      },
    }),
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        textAlign: "center",
        width: "100%",
      }}
    >
      {" "}
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Box
        sx={{
          width: "100%",
          justifyContent: "center",
          alignContent: "center",
          justifyItems: "center",
          justifyItems: "center",
          textAlign: "center",
        }}
      >
        {castingCubesData.map((data, index) => (
          <Paper
            sx={{
              padding: "15px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "5px",
            }}
            elevation={3}
            key={index}
          >
            {/* <MaterialReactTable table={table} /> */}
            <Box display="flex" justifyContent="space-between">
              <Typography variant="h5" color="error">{`JOB/${
                data?.labRequest.year
              }/${String(data?.labRequest.autoIdByYear).padStart(4, "0")}`}</Typography>

              <Box display="flex" gap={1} alignItems="center">
                <Typography
                  variant="h5"
                  color="error"
                >{`Job date : ${data?.labRequest.regDate}`}</Typography>
                <IconButton
                  onClick={() => {
                    setSelectedRequestId(data);
                    setOpenLabSheetDialog(true);
                  }}
                  color="info"
                >
                  <FileDownload sx={{ fontSize: "25px" }} />
                </IconButton>
              </Box>
            </Box>
            <Divider />

            <Typography variant="h5" color="info" textAlign="start">
              {`${data?.labRequest.institute.instituteName}`}
            </Typography>

            <Typography variant="h5" color="success" textAlign="start">
              {`Project : ${data?.labRequest.project}`}
            </Typography>

            <Divider />
            <Box gap={2} display="flex" flexDirection="row">
              <Box display="flex" flexDirection="column">
                <Box display="flex" gap={1}>
                  <CalendarMonth color="info" />
                  <Typography variant="h5" color="info" textAlign="start">
                    {`Casting Date`}
                  </Typography>
                </Box>
                <Typography variant="h5" color="info" textAlign="center">
                  {`${data?.castingDate}`}
                </Typography>
              </Box>

              <Box display="flex" flexDirection="column">
                <Box display="flex" gap={1}>
                  <AssignmentTurnedIn color="info" />
                  <Typography variant="h5" color="info" textAlign="start">
                    {`Test Date`}
                  </Typography>
                </Box>
                <Typography variant="h5" color="info" textAlign="center">
                  {`${data?.testDate}`}
                </Typography>
              </Box>

              <Box display="flex" flexDirection="column">
                <Box display="flex" gap={1}>
                  <FormatListBulleted color="warning" />
                  <Typography variant="h5" color="warning" textAlign="start">
                    {`Starting Serial No`}
                  </Typography>
                </Box>
                <Typography variant="h5" color="warning" textAlign="center">
                  {`${data?.startingSerialNo}`}
                </Typography>
              </Box>

              <Box display="flex" flexDirection="column">
                <Box display="flex" gap={1}>
                  <ViewInAr color="warning" />
                  <Typography variant="h5" color="warning" textAlign="start">
                    {`Quantity`}
                  </Typography>
                </Box>
                <Typography variant="h5" color="warning" textAlign="center">
                  {`${data?.quantity}`}
                </Typography>
              </Box>
            </Box>
            <Divider sx={{ marginTop: "5px" }} />
            <Box mt={1}>
              <ConcreteCubeAccordingData
                start={data.startingSerialNo}
                quantity={data.quantity}
              />
            </Box>
            <Divider sx={{ marginTop: "5px" }} />
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default ConcreteCubesToBeCasted;
